export default __webpack_public_path__ + "static/media/churn.a3857d0d.png";